<div
  [ngClass]="{ 'cursor-pointer': column.isClickable }"
  (click)="columnClicked()">
  <ng-container [ngSwitch]="column.type">
    <!-- String Type -->
    <ng-container *ngSwitchCase="'string'">
      <ng-container *ngTemplateOutlet="stringTemplate"></ng-container>
    </ng-container>
    <!-- LongText Type -->
    <ng-container *ngSwitchCase="'longText'">
      <ng-container *ngTemplateOutlet="stringTemplate"></ng-container>
    </ng-container>

    <!-- Email Type -->
    <ng-container *ngSwitchCase="'email'">
      <a
        class="link"
        [ngClass]="{ 'white-space-nowrap': column.forceSingleLine }"
        href="mailto:{{ value }}">
        {{ value }}
      </a>
    </ng-container>

    <!-- Telephone Type -->
    <ng-container *ngSwitchCase="'telephone'">
      <a
        class="link"
        [ngClass]="{ 'white-space-nowrap': column.forceSingleLine }"
        href="tel:{{ value }}">
        {{ value }}
      </a>
    </ng-container>

    <!-- Enum Type -->
    <ng-container *ngSwitchCase="'enum'">
      <span
        *ngIf="column.translatePath && column.optionLabel === 'key' && column.translatePath === 'countries'">
        {{ column.translatePath + '.' + value | translate }}
      </span>
      <span *ngIf="column.translatePath && value">
        {{ column.translatePath + '.' + value | translate }}
      </span>
    </ng-container>

    <!-- Dropdown Type -->
    <ng-container *ngSwitchCase="'dropdown'">
      <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
    </ng-container>

    <!-- Number Type -->
    <ng-container *ngSwitchCase="'number'"> {{ value | number }} </ng-container>

    <!-- Currency Type -->
    <ng-container *ngSwitchCase="'currency'">
      {{ value | currency }}
    </ng-container>

    <!-- Date Type -->
    <ng-container *ngSwitchCase="'date'">
      <span [ngClass]="{ 'white-space-nowrap': column.forceSingleLine }">
        {{ value | date: 'dd.MM.yyyy' }}
      </span>
    </ng-container>

    <!-- Boolean Type -->
    <ng-container *ngSwitchCase="'boolean'">
      <ng-container [ngSwitch]="column.booleanStyle">
        <ng-container *ngSwitchCase="'icon'">
          <ng-container *ngTemplateOutlet="booleanIconTemplate"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'switch'">
          <ng-container
            *ngTemplateOutlet="booleanSwitchTemplate"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'text'">
          {{ value ? 'Yes' : 'No' }}
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ value ? 'Yes' : 'No' }}
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- Count Type -->
    <ng-container *ngSwitchCase="'count'">
      <ng-container *ngTemplateOutlet="countTemplate"></ng-container>
    </ng-container>

    <!-- User Type -->
    <ng-container *ngSwitchCase="'user'">
      <div class="flex align-items-center gap-2">
        <app-user-avatar [user]="value"></app-user-avatar>
        <span>{{ value.firstname }} {{ value.lastname }}</span>
      </div>
    </ng-container>

    <!-- Autocomplete Type -->
    <ng-container *ngSwitchCase="'autocomplete'"> {{ value }} </ng-container>

    <app-dynamic-column-comp
      *ngSwitchCase="'component'"
      [editObject]="object"
      [columnConfig]="column"></app-dynamic-column-comp>

    <!-- Default Case -->
    <ng-container *ngSwitchDefault> {{ value }} </ng-container>
  </ng-container>
</div>

<!-- Templates -->
<ng-template #stringTemplate>
  <span *ngIf="column.cutOffWithTooltip">
    <span
      class="cut-text"
      [pTooltip]="(column.translatePath + '.' + value) | translate"
      *ngIf="column.translatePath && column.optionLabel === 'key' && column.translatePath === 'countries'">
      {{ column.translatePath + '.' + value | translate }}
    </span>
    <span
      [pTooltip]="value"
      class="cut-text"
      [ngStyle]="{
        'max-width.px': column.cutOffWithTooltip === true ? 500 : column.cutOffWithTooltip,
        'min-width.px': column.minWidth
      }">
      {{ value }}
    </span>
  </span>
  <span *ngIf="!column.cutOffWithTooltip">
    <span
      [ngClass]="{ 'white-space-nowrap': column.forceSingleLine }"
      *ngIf="column.translatePath && column.optionLabel === 'key' && column.translatePath === 'countries'">
      {{ column.translatePath + '.' + value | translate }}
    </span>
    <span [ngClass]="{ 'white-space-nowrap': column.forceSingleLine }">
      {{ value }}
    </span>
  </span>
</ng-template>

<ng-template #dropdownTemplate>
  <span
    *ngIf="column.translatePath && column.optionLabel && value && value[column.optionLabel]">
    {{ column.translatePath + '.' + value[column.optionLabel] | translate }}
  </span>
  <span
    *ngIf="!column.translatePath && column.optionLabel && !column.optionLabel2 && !column.scaffolded && !column.scaffoldedField">
    {{ value[column.optionLabel] ? value[column.optionLabel] : value }}
  </span>
  <span
    *ngIf="!column.translatePath && column.optionLabel && column.optionLabel2 && !column.scaffolded && !column.scaffoldedField">
    {{ value[column.optionLabel] && value[column.optionLabel2] ?
    value[column.optionLabel] + ' ' + value[column.optionLabel2] : value }}
  </span>
  <span
    *ngIf="!column.translatePath && column.optionLabel && column.scaffolded && column.scaffoldedField">
    {{ value[column.scaffoldedField][column.optionLabel] ?
    value[column.scaffoldedField][column.optionLabel] : value }}
  </span>
  <span *ngIf="!column.translatePath && !column.optionLabel">
    {{ value.label }}
  </span>
</ng-template>

<ng-template #booleanIconTemplate>
  <div
    class="flex align-items-center justify-content-center"
    [ngStyle]="{
      'background-color': showCheck ? '#7AAA00' : '#FF0000',
      'border-radius': '1.5rem',
      width: '1.5rem',
      height: '1.5rem',
      color: '#f1f1f1'
    }">
    <i *ngIf="showCheck" class="pi pi-check text-xs"></i>
    <i
      *ngIf="!showCheck"
      class="pi pi-times text-xs"
      [ngStyle]="{ marginTop: '0.12rem' }"></i>
  </div>
</ng-template>

<ng-template #booleanSwitchTemplate>
  <ng-container *ngIf="$can(column.permissionAction)">
    <p-toggleswitch
      name="toggle-cb-{{ column.field }}"
      [(ngModel)]="checked"
      (ngModelChange)="onSwitchValueChanged($event)"></p-toggleswitch>
  </ng-container>
  <ng-container *ngIf="!$can(column.permissionAction)">
    <i [ngClass]="value ? 'pi pi-check' : 'pi pi-times'"></i>
  </ng-container>
</ng-template>

<ng-template #countTemplate>
  <ng-container *ngIf="column.referringKey && object[column.referringKey]">
    <div class="link" (click)="op.toggle($event)">
      <span
        [pTooltip]="'general.show' | translate"
        tooltipPosition="top"
        *ngIf="object[column.referringKey].length && object[column.referringKey].length > 0">
        {{ object[column.referringKey].length }}
      </span>
    </div>
    <p-popover #op [dismissable]="false">
      <div class="w-full text-right">
        <span class="pi pi-times link" (click)="op.hide()"></span>
      </div>
      <app-files
        *ngIf="config.fileDownloadContext"
        [showUploadComponent]="true"
        [showFilterBar]="true"
        [filesList]="object[column.referringKey]"
        [context]="config.fileDownloadContext"
        (upload)="valueChangedWithoutConfirm($event)"
        (fileRemoved)="onSwitchValueChanged($event)"
        [showUploadBtn]="$can(column.permissionAction)"
        [showRemoveBtn]="$can(column.permissionAction)"
        [showCustomButton]="$can(column.permissionAction)"
        [showUploadComponent]="$can(column.permissionAction)">
      </app-files>
    </p-popover>
  </ng-container>
  <ng-container
    *ngIf="!column.referringKey || !object[column.referringKey] || object[column.referringKey].length === 0">
    0
  </ng-container>
</ng-template>
